import React from 'react';
import { BsCheckCircleFill, BsExclamationCircleFill } from 'react-icons/bs';

const ValidatedInput = ({
  id,
  name,
  type = 'text',
  value,
  onChange,
  onBlur,
  placeholder,
  label,
  error,
  touched,
  showRequired = false,
  className = '',
  ...props
}) => {
  const hasError = touched && error;
  const isValid = touched && !error && value;

  const getBorderColor = () => {
    if (hasError) return 'border-red-500 focus:border-red-500 focus:ring-red-500';
    if (isValid) return 'border-green-500 focus:border-green-500 focus:ring-green-500';
    return 'border-gray-300 focus:border-purple-500 focus:ring-purple-500';
  };

  return (
    <div className="flex flex-col gap-2">
      {label && (
        <label 
          htmlFor={id} 
          className="block text-gray-700 text-sm font-semibold"
        >
          {label} {showRequired && <span className="text-red-500">*</span>}
        </label>
      )}
      
      <div className="relative">
        <input
          id={id}
          name={name}
          type={type}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          placeholder={placeholder}
          className={`
            w-full px-4 py-3 rounded-lg border-2 
            transition-all duration-200 ease-in-out
            ${getBorderColor()}
            focus:outline-none focus:ring-2 focus:ring-opacity-50
            ${hasError ? 'bg-red-50' : isValid ? 'bg-green-50' : 'bg-white'}
            ${className}
          `}
          {...props}
        />
        
        {/* Validation icon - hide for date/time inputs as they have their own icons */}
        {(hasError || isValid) && type !== 'date' && type !== 'time' && type !== 'datetime-local' && (
          <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
            {hasError && (
              <BsExclamationCircleFill 
                className="text-red-500 animate-pulse" 
                size={20} 
              />
            )}
            {isValid && (
              <BsCheckCircleFill 
                className="text-green-500" 
                size={20} 
              />
            )}
          </div>
        )}
      </div>
      
      {/* Error message */}
      {hasError && (
        <div className="flex items-start gap-2 text-red-600 text-sm animate-slideDown">
          <BsExclamationCircleFill className="mt-0.5 flex-shrink-0" size={14} />
          <span>{error}</span>
        </div>
      )}
    </div>
  );
};

export default ValidatedInput;
